import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Chat.css';
import PropTypes from 'prop-types';
const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Chat extends Component {
	render() {
		return (
			<React.Fragment>
			{ this.props.streamConfig && this.props.streamConfig.vimeo_video_id &&
				<div className={this.props.isChatOpen ? 'showtix-chat is-active' : 'showtix-chat'}>
					<div className="showtix-chat__body">
						<iframe src={`https://vimeo.com/live-chat/${this.props.streamConfig.vimeo_video_id}/`} width="100%" height="100%"
								frameBorder="0"></iframe>
					</div>
				</div>
			}
			</React.Fragment>
		);
	}
}

Chat.propTypes = {
	isChatOpen: PropTypes.bool,
	streamEvent: PropTypes.object,
	streamConfig: PropTypes.object,
	toggleChat: PropTypes.func,
};

export default Chat;




// WEBPACK FOOTER //
// ./src/components/Chat/Chat.js